import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@systemeio/components';
import React from 'react';
const SalesFunnelsSettingsSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="bg-bg-primary border-border-100 desktop:gap-10 flex h-fit w-full flex-col gap-7 overflow-x-hidden rounded-md border p-5"><Skeleton className="h-5 w-40" /><Skeleton className="size-60" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default SalesFunnelsSettingsSkeleton;